import React from 'react';
import { Heading } from '@chatsdet/ui';

export interface DigestSectionHeadingProps {
  children: React.ReactNode;
  /** The closing words, shown in the accent colour ("this week."). */
  accent?: string;
}

/** The digest page's section heading: plain words, optionally ending in accent-coloured ones. */
export function DigestSectionHeading({ children, accent }: DigestSectionHeadingProps) {
  return (
    <Heading level={2} size="2xl" className="text-balance">
      {children}
      {accent && (
        <>
          {' '}
          <span className="text-primary">{accent}</span>
        </>
      )}
    </Heading>
  );
}
